import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AdminPanel } from '../pages/admin-panel/AdminPanel';
import { SystemAnnouncementTreeView } from '../pages/admin-panel/system-announcements/SystemAnnouncementTreeView';
import { SystemUserManagementPage } from '../pages/admin-panel/system-right-management/SystemUserManagementPage';
import { SystemSettingsView } from '../pages/admin-panel/SystemSettingsView';
import { ApplicationShell } from '../pages/ApplicationShell';
import { ProjectUserManagementPage } from '../pages/project-user-management/ProjectUserManagementPage';
import { NotFoundComponent } from '../reusable-components/NotFoundComponent';
import type { Path } from './route';
import { ProjectsComponent } from '../pages/projects/ProjectsComponent';
import { ProjectComponent } from '../pages/project/ProjectComponent';
import { WorkFlowRepresentationsComponent } from '../pages/workflow-representation/WorkFlowRepresentationsComponent';
import { ProcessAreaComponent } from '../pages/process-area/ProcessAreaComponent';
import { BPMNModelerEditor } from '../pages/bpmn-modeler-demo/BPMNModelerEditor';

// TODO all these components should be called ...Page and should be in /pages
const routeToElement: Record<Path, ReactNode> = {
    ['/']: <Navigate to={'/projects'} replace />,
    ['/auth/oidc/callback/login']: <Navigate to={'/projects'} replace />,
    ['/admin-panel']: <AdminPanel />,
    ['/admin-panel/system-settings']: <SystemSettingsView />,
    ['/admin-panel/system-right-management']: <SystemUserManagementPage />,
    ['/admin-panel/system-announcements']: <SystemAnnouncementTreeView />,
    ['/project-user-management/:id']: <ProjectUserManagementPage />,
    ['/projects']: <ProjectsComponent />,
    ['/project/:id']: <ProjectComponent />,
    ['/project/:id/active-version/:versionId']: <ProjectComponent />,
    ['/project/:id/active-version/:versionId/standard/:standardId/use-case/:useCaseId']: <ProjectComponent />,

    ['/project/:id/published-use-case/:useCaseObjectId']: <WorkFlowRepresentationsComponent/>,
    ['/project/:id/published-use-case/:useCaseObjectId/published-workflow-representation/:workflowObjectId']: <WorkFlowRepresentationsComponent/>,
    ['/project/:id/active-version/:versionId/standard/:standardId/use-case/:useCaseId/workflow-representations']: <WorkFlowRepresentationsComponent/>,

    ['/project/:id/published-process-area/:processAreaObjectId']: <ProcessAreaComponent/>,
    ['/project/:id/published-process-area/:processAreaObjectId/published-use-case/:useCaseObjectId']: <ProcessAreaComponent/>,
    ['/project/:id/published-process-area/:processAreaObjectId/published-use-case/:useCaseObjectId/published-workflow-representation/:workflowObjectId']: <ProcessAreaComponent/>,
    ['/project/:id/active-version/:versionId/process-area/:processAreaId']: <ProcessAreaComponent/>,
    ['/project/:id/active-version/:versionId/process-area/:processAreaId/standard/:standardId/use-case/:useCaseId']: <ProcessAreaComponent/>,
    ['/project/:id/active-version/:versionId/process-area/:processAreaId/standard/:standardId/use-case/:useCaseId/workflow-representation/:workflowId']: <ProcessAreaComponent/>,

    ['/project/:id/active-version/:versionId/activities-model/:activitiesId']: <BPMNModelerEditor/>,
    ['/project/:id/active-version/:versionId/activities-model/:activitiesId/standard/:standardId/use-case/:useCaseId']: <BPMNModelerEditor/>,
    ['*']: <NotFoundComponent />,
};

const router = createBrowserRouter([
    {
        element: <ApplicationShell />,
        children: Object.entries(routeToElement).map(([path, element]) => ({ path, element })),
    },
]);

export const AuthenticatedApp = () => {
    return <RouterProvider router={router} />;
};
